import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAnalyticsFilters } from "store/actions/analytics";
import { useTheme } from "@mui/material/styles";

const PERIODS = [
  { label: "Today", key: "today" },
  { label: "7 Days", key: "7d" },
  { label: "1 Month", key: "1m" },
  { label: "6 Months", key: "6m" },
  { label: "Custom", key: "custom" }
];

export default function AnalyticsFilters({ classes, onRefresh, showGranularity = false, showSync = true }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const dispatch = useDispatch();

  const { analyticsFilters = {}, analyticsLoading } = useSelector((state) => state.analytics);

  const handleFilterChange = (key, val) => {
    dispatch(setAnalyticsFilters({ ...analyticsFilters, [key]: val }));
  };

  const handleRefresh = () => {
    if (onRefresh) onRefresh();
  };

  return (
    <div className={classes.controlBar} style={{ justifyContent: "flex-end" }}>
      <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", alignItems: "center" }}>
        <div className={classes.periodPills}>
          {PERIODS.map((p) => (
            <button
              key={p.key}
              className={`${classes.pill} ${analyticsFilters.period === p.key ? classes.pillActive : ""}`}
              onClick={() => handleFilterChange("period", p.key)}
            >
              {p.label}
            </button>
          ))}
        </div>

        {analyticsFilters.period === "custom" && (
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <input
              type="date"
              className={classes.inputField}
              value={analyticsFilters.from || ""}
              onChange={(e) => handleFilterChange("from", e.target.value)}
            />
            <span style={{ color: isDark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)" }}>to</span>
            <input
              type="date"
              className={classes.inputField}
              value={analyticsFilters.to || ""}
              onChange={(e) => handleFilterChange("to", e.target.value)}
            />
          </div>
        )}

        {showGranularity && (
          <select
            className={classes.inputField}
            style={{ width: "120px" }}
            value={analyticsFilters.granularity || "day"}
            onChange={(e) => handleFilterChange("granularity", e.target.value)}
          >
            <option value="day">Daily</option>
            <option value="week">Weekly</option>
            <option value="month">Monthly</option>
          </select>
        )}

        <input
          type="text"
          placeholder="Timezone"
          className={classes.inputField}
          style={{ width: "140px" }}
          value={analyticsFilters.timezone || "Africa/Cairo"}
          onChange={(e) => handleFilterChange("timezone", e.target.value)}
        />
      </div>
      {showSync && (
        <button className={classes.refreshBtn} onClick={handleRefresh} disabled={analyticsLoading}>
          {analyticsLoading ? "Syncing…" : "Sync"}
        </button>
      )}
    </div>
  );
}

